import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Mongo } from 'src/app/core/models/mongo';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatDialogClose } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-add-action',
    styles: [':host { display: block; max-width: 500px }'],
    template: `
    <h4 class="text-center my-3">{{ 'PLANNING.ACTIONS.NEW' | translate }}</h4>
    <form [formGroup]="actionForm" class="row">
      <mat-form-field appearance="outline" class="col-12">
        <mat-label>{{ 'PLANNING.ACTIONS.TITLE' | translate }}</mat-label>
        <input matInput formControlName="title" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-12">
        <mat-label>{{ 'PLANNING.ACTIONS.DESCRIPTION' | translate }}</mat-label>
        <textarea matInput formControlName="description"></textarea>
      </mat-form-field>
    </form>

    <section class="d-flex justify-content-center my-3">
      <button mat-flat-button mat-dialog-close>
        {{ 'CANCEL' | translate }}
      </button>
      <button mat-flat-button color="accent" [mat-dialog-close]="actionForm.value" [disabled]="!actionForm.valid">
        {{ 'CONFIRM' | translate }}
      </button>
    </section>
  `,
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatButton, MatDialogClose, TranslateModule]
})
export class AddActionDialogComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);

  actionForm!: UntypedFormGroup;

  ngOnInit(): void {
    this.actionForm = this.fb.group({
      _id: [new Mongo.ObjectId()],
      title: ['', Validators.required],
      description: ['', Validators.required],
    });
  }
}
